/**
 * @generated SignedSource<<0e5ad57e7ce6ead6dfad2bb0c96c0e57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTournament",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "splitCategories",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "CompetitionConfiguration",
  "kind": "LinkedField",
  "name": "competitionConfiguration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Tournament",
      "kind": "LinkedField",
      "name": "tournament",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "excludeKnockOutRounds",
              "value": true
            }
          ],
          "concreteType": "TournamentRound",
          "kind": "LinkedField",
          "name": "tournamentRounds",
          "plural": true,
          "selections": [
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "round",
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": "tournamentRounds(excludeKnockOutRounds:true)"
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playerId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionConfigurationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionConfiguration",
            "kind": "LinkedField",
            "name": "competitionConfiguration",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CompetitionMatchups_competitionConfiguration"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionConfigurationGroups_tournament"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionConfigurationKnockOut_tournament"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompetitionConfigurationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionConfiguration",
            "kind": "LinkedField",
            "name": "competitionConfiguration",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionGroup",
                "kind": "LinkedField",
                "name": "competitionGroups",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompetitionMatchup",
                    "kind": "LinkedField",
                    "name": "competitionMatchups",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tournamentRoundId",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompetitionGroup",
                        "kind": "LinkedField",
                        "name": "competitionGroup",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompetitionPlayer",
                            "kind": "LinkedField",
                            "name": "competitionPlayers",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompetitionPlayer",
                        "kind": "LinkedField",
                        "name": "competitionPlayers",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tournamentRoundIds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Player",
                            "kind": "LinkedField",
                            "name": "player",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Matchplay",
                        "kind": "LinkedField",
                        "name": "matchplays",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MatchplayPlayer",
                            "kind": "LinkedField",
                            "name": "matchplayPlayers",
                            "plural": true,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlightScore",
                                "kind": "LinkedField",
                                "name": "flightScore",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasScores",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompetitionPlayer",
                    "kind": "LinkedField",
                    "name": "competitionPlayers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "competitionMatchupPlayersCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "holesLost",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "holesWon",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "losses",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lossesAfterPenaltyPutts",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "points",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "position",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "wins",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "winsAfterPenaltyPutts",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v8/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionPlayer",
                "kind": "LinkedField",
                "name": "competitionPlayers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "competitionGroupId",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Player",
                    "kind": "LinkedField",
                    "name": "player",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TournamentPlayer",
                    "kind": "LinkedField",
                    "name": "tournamentPlayer",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tournamentId",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionKnockOutLayer",
                "kind": "LinkedField",
                "name": "competitionKnockOutLayers",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roundOf",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "has55Plus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasJuniors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasMen",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasSeniors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasWomen",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e1cdc31393df682dd15f0c42f3f08496",
    "id": null,
    "metadata": {},
    "name": "CompetitionConfigurationQuery",
    "operationKind": "query",
    "text": "query CompetitionConfigurationQuery(\n  $id: ID!\n) {\n  tournament(id: $id) {\n    competitionConfiguration {\n      endDate\n      id\n      isTournament\n      splitCategories\n      startDate\n      ...CompetitionMatchups_competitionConfiguration\n    }\n    ...CompetitionConfigurationGroups_tournament\n    ...CompetitionConfigurationKnockOut_tournament\n    id\n  }\n}\n\nfragment CompetitionConfigurationGroup_competitionGroup on CompetitionGroup {\n  databaseId\n  id\n  name\n  competitionPlayers {\n    competitionMatchupPlayersCount\n    holesLost\n    holesWon\n    id\n    losses\n    lossesAfterPenaltyPutts\n    points\n    position\n    wins\n    winsAfterPenaltyPutts\n    player {\n      databaseId\n      name\n      id\n    }\n  }\n}\n\nfragment CompetitionConfigurationGroups_tournament on Tournament {\n  has55Plus\n  hasJuniors\n  hasMen\n  hasSeniors\n  hasWomen\n  competitionConfiguration {\n    id\n    splitCategories\n    competitionGroups {\n      category\n      id\n      ...CompetitionConfigurationGroup_competitionGroup\n    }\n    competitionPlayers {\n      competitionGroupId\n      id\n      player {\n        name\n        id\n      }\n      tournamentPlayer {\n        category\n        tournamentId\n        id\n      }\n    }\n  }\n}\n\nfragment CompetitionConfigurationKnockOutLayer_competitionKnockOutLayer on CompetitionKnockOutLayer {\n  roundOf\n}\n\nfragment CompetitionConfigurationKnockOut_tournament on Tournament {\n  competitionConfiguration {\n    id\n    competitionKnockOutLayers {\n      id\n      roundOf\n      ...CompetitionConfigurationKnockOutLayer_competitionKnockOutLayer\n    }\n  }\n}\n\nfragment CompetitionMatchup_competitionMatchup on CompetitionMatchup {\n  id\n  tournamentRoundId\n  competitionConfiguration {\n    tournament {\n      tournamentRounds(excludeKnockOutRounds: true) {\n        databaseId\n        round\n        id\n      }\n      id\n    }\n    id\n  }\n  competitionGroup {\n    name\n    competitionPlayers {\n      id\n      playerId\n    }\n    id\n  }\n  competitionPlayers {\n    id\n    tournamentRoundIds\n    player {\n      id\n      name\n    }\n  }\n  matchplays {\n    matchplayPlayers {\n      playerId\n      flightScore {\n        hasScores\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment CompetitionMatchupsGroup_competitionGroup on CompetitionGroup {\n  id\n  competitionConfiguration {\n    tournament {\n      tournamentRounds(excludeKnockOutRounds: true) {\n        databaseId\n        round\n        id\n      }\n      id\n    }\n    id\n  }\n  competitionMatchups {\n    id\n    tournamentRoundId\n    ...CompetitionMatchup_competitionMatchup\n  }\n}\n\nfragment CompetitionMatchups_competitionConfiguration on CompetitionConfiguration {\n  id\n  splitCategories\n  competitionGroups {\n    category\n    id\n    name\n    ...CompetitionMatchupsGroup_competitionGroup\n  }\n}\n"
  }
};
})();

node.hash = "a7402518413fbf1eca42e7bfbd5d085e";

module.exports = node;
